module.exports = __webpack_public_path__ + "static/aws_partner_badge-9596e85f0206855c36f71ccae35c7206.png";